export default __webpack_public_path__ + "static/media/Intuit_QuickBooks_logo.daaf6478.png";